module.exports = __webpack_public_path__ + "static/media/206-Telefonat_ID_25.e73f8ad5.mp3";